export default __webpack_public_path__ + "static/media/logo-sso-google-white.8be7787f.svg";